import { render, staticRenderFns } from "./CollapseContentBlockWithTitle.vue?vue&type=template&id=6a27ab86&scoped=true&"
import script from "./CollapseContentBlockWithTitle.vue?vue&type=script&lang=js&"
export * from "./CollapseContentBlockWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./CollapseContentBlockWithTitle.vue?vue&type=style&index=0&id=6a27ab86&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a27ab86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a27ab86')) {
      api.createRecord('6a27ab86', component.options)
    } else {
      api.reload('6a27ab86', component.options)
    }
    module.hot.accept("./CollapseContentBlockWithTitle.vue?vue&type=template&id=6a27ab86&scoped=true&", function () {
      api.rerender('6a27ab86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/contents/CollapseContentBlockWithTitle.vue"
export default component.exports